module.exports = __webpack_public_path__ + "static/media/YM27_4.f62d0de3.jpg";